import {mapActions, mapState} from 'vuex'
import {addSMERefer, downloadSMEPdf, downloadSMEPdfDiret, SMEBuyPolicy} from '@api/sme'
import {getAccountDetail} from '@api/account'
import {downloadFile} from '@/utils/download'
import {productAPiPath, smeClassId} from '@/utils/smePath'

export default {
  data() {
    return {
      step: 0,
      customerData:{},
      order_sn:'',
      same_customer:false,
      initContent:'',
      emailTitle: '',
      emailListTitle: ''
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('smeQuote', ['smeQuickForm','estimatedPremium']),
    ...mapState('account', ['customerId','selectCustomerData']),
    smeType(){
      return productAPiPath[this.productId]||'catering'
    },
    sme_class_id(){
      let {type} = this.$route.params
      return smeClassId[type]
    },

  },
  watch:{
    customerId:{
      immediate:true,
      handler(val,old=''){
        if(val==old){
          this.same_customer = false
        }else this.same_customer = true
      }
    }
  },
  methods: {
    ...mapActions('smeQuote', ['setSmeQuickForm']),
    handlerContent(detailData){
      let {customer_profile={}} = detailData||{}
      let name = this.getOptionName('classOptions', this.productId)
      let nameZh = this.getOptionName('classChinaOptions', this.productId)
      let {identity,language} = customer_profile
      let data =''
      if(identity==2){
        data = '你的報價申請需要特別審核，我們的客戶服務主任會盡快與你聯絡並作出跟進。'
        if(language=='en-US')
          data = 'Your quotation requires further underwriting. Our Customer Service Representative will be in contact with you shortly.'
      }else{
        data = `你的${ nameZh }保險報價申請需要特別審核，我們的客戶服務主任會盡快與你聯絡並作出跟進。`
        if(language=='en-US')
          data =  `Your ${name} Insurance quotation requires further underwriting. Our Customer Service Representative will be in contact with you shortly.\n`
      }
      this.initContent =  data
      this.emailListTitle = '報價申請通知'
      this.emailTitle = `${ nameZh }保險報價申請需要特別審核`
    },
    async handleSmeNext(){
      if(!this.order_sn||this.same_customer){
        await this.mixinSMENetwork().SMEBuyPolicy()
      }
      this.$router.push({
        path:`/quoting/${this.smeType}/buy/policy`,
        query:{
          order_id:this.order_sn
        }
      })
    },
    async handleDownloadPdf(){
      // if(!this.customerId){
      //   this.$message({
      //     type: 'warning',
      //     message: '請先選擇用戶'
      //   })
      //   return
      // }
      // if(this.same_customer)
      //   await this.mixinSMENetwork().SMEBuyPolicy()
      // if(this.order_sn)
      if(this.customerId){
        if(this.same_customer){
          await this.mixinSMENetwork().SMEBuyPolicy()
          this.mixinSMENetwork().downloadSMEPdf()
        }
        else  this.mixinSMENetwork().downloadSMEPdf()
      }
      else this.mixinSMENetwork().downloadSMEPdfDiret()

    },
    async getAccountDetail() {
      const {data} = await getAccountDetail({
        customer_id: this.customerId,
        hideLoading:true
      })
      this.handlerContent(data)
      this.customerData = data.customer_profile
      this.$refs['send-form'].changeDialog()
    },
    handlerEmailSmsSend(content){
      const params = {
        content,
        is_send: 1
      }
      this.mixinSMENetwork().addSMERefer(params)
    },
    handlerEmailSmsSkip() {
      const params = {
        content: '',
        is_send: 0
      }
      this.mixinSMENetwork().addSMERefer(params)
    },
    mixinSMENetwork() {
      return {
        addSMERefer:async (params) => {
          // let {
          //   isrd_title,
          //   contact_nm,
          //   contact_phone,
          //   contact_email} = this.selectCustomerData
          // params.contact_us ={
          //   contact_title:isrd_title,
          //   contact_nm,
          //   contact_phone,
          //   contact_email,
          //   ...params,
          //   customer_id:this.customerId
          // }
          params ={
            ...params,
            customer_id:this.customerId
          }
          params = {...params,...this.smeQuickForm}
          let {data} = await addSMERefer(params,this.productId)
          this.$router.replace({
            path: '/tickets/detail',
            query: {
              ticket_id: data.ticket_id
            }
          })
        },
        downloadSMEPdf: async (params) => {
          const res = await downloadSMEPdf({
            order_id: this.order_sn,
            customer_id:this.customerId
          },this.productId)
          downloadFile(res)
        },
        downloadSMEPdfDiret: async (params) => {
          const res = await downloadSMEPdfDiret({
            // order_id: this.order_sn,
            // customer_id:this.customerId
            ...this.smeQuickForm
          },this.productId)
          downloadFile(res)
        },

        SMEBuyPolicy: async (params) => {
          params = {...this.smeQuickForm}
          const {data} = await SMEBuyPolicy({
            ...params,
            order_id: this.order_sn,
            customer_id:this.customerId
          },this.productId)
          let {order_id	} = data
          this.order_sn = order_id
          this.same_customer = false
        },
      }
    }
  }
}
